import * as tslib_1 from "tslib";
import * as React from 'react';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, } from 'material-ui/Table';
var styles = {
    status: {
        fontSize: '12px',
        color: '#fff',
        padding: 3,
        textAlign: 'center',
        borderRadius: '3px'
    }
};
import { TaskStatus } from 'src/models/TaskStatus';
export var StatisticTaskTable = function (_a) {
    var tasks = _a.tasks;
    return React.createElement(Table, { selectable: false },
        React.createElement(TableHeader, { displaySelectAll: false, adjustForCheckbox: false },
            React.createElement(TableRow, null,
                React.createElement(TableHeaderColumn, { style: { width: '120px' } }, "St\u00E1tusz"),
                React.createElement(TableHeaderColumn, null, "Feladat"),
                React.createElement(TableHeaderColumn, null, "Tervezett (\u00F3ra)"),
                React.createElement(TableHeaderColumn, null, "R\u00E1ford\u00EDt\u00E1s (\u00F3ra)"))),
        React.createElement(TableBody, { displayRowCheckbox: false }, tasks.map(function (i) {
            return React.createElement(TableRow, { key: i.key },
                React.createElement(TableRowColumn, { style: { width: '120px' } },
                    React.createElement("div", { style: tslib_1.__assign({}, styles.status, { backgroundColor: TaskStatus.colorify(i.status) }) }, TaskStatus.stringify(i.status))),
                React.createElement(TableRowColumn, null,
                    React.createElement("span", { title: i.key }, i.key)),
                React.createElement(TableRowColumn, null, i.planned),
                React.createElement(TableRowColumn, null, i.spent));
        })));
};



//////////////////
// WEBPACK FOOTER
// ./src/pages/statistics/StatisticTaskTable.tsx
// module id = 311
// module chunks = 0